import React from 'react';
import Modal from './Modal';

const ViewTransactionModal = ({ transaction, onClose, onEdit, show }) => {
  if (!show || !transaction) return null;

  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Transaction Details"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={() => onEdit(transaction)}>
            Edit Transaction
          </button>
        </>
      }
    >
      <div className="transaction-details">
        <div className="detail-group">
          <label>Transaction ID</label>
          <p>{transaction.transaction_public_id}</p>
        </div>
        <div className="detail-group">
          <label>Customer</label>
          <p>{transaction.customer}</p>
        </div>
        <div className="detail-group">
          <label>Amount</label>
          <p className="amount">{transaction.amount}</p>
        </div>
        <div className="detail-group">
          <label>Status</label>
          <span className={`status-badge ${transaction.status.toLowerCase()}`}>
            {transaction.status}
          </span>
        </div>
        <div className="detail-group">
          <label>Date</label>
          <p>{transaction.date}</p>
        </div>
      </div>
    </Modal>
  );
};

export default ViewTransactionModal; 